import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import UserList from './UserList';

function UsersLists() {
    return ( 
        <Container>
            <Navbar/>

            <Content>
                <UserList/>
            </Content>
        </Container>
     );
}

export default UsersLists;